module.exports = __webpack_public_path__ + "static/media/eye-evil.8059c528.svg";